'use strict';

import { Modal } from '@lf/mwuikit/src/scripts/objects/modal';
import { getLifeInsuranceSubscriptionAlert } from "../../api/getLifeInsuranceSubscriptionAlert";

(function () {
    function displaySubscriptionAlertModal(e) {
        let modal = Modal({ isAlignCenter: true });
        modal.init();
        modal.show(`<p id="modal-title" class="title centered">Vous avez déjà une opération en cours sur votre contrat d’Assurance&nbsp;Vie</p>
        	             <p id="modal-description" class="text centered">Pour toute question relative à votre dossier, n'hésitez pas à <a href="${API_ENDPOINT}nous-contacter">nous&nbsp;contacter</a> ou à <a href="${API_ENDPOINT}prendre-rendez-vous">prendre rendez-vous avec l'un de nos conseillers&nbsp;!</a></p>
        	            <a class="cta" tabindex="1" href="${API_ENDPOINT}espace-client">Poursuivre</a>
                   `);
    }

    function check(e) {
        e.preventDefault();

        getLifeInsuranceSubscriptionAlert(
            function (response) {
                if (response) {
                    displaySubscriptionAlertModal(e);
                } else {
                    window.location = e.target.href;
                }
            },
            function () {

            }
        );
    }

    let subscribeOnline = document.getElementById('cta-j-investis');
    if (subscribeOnline) {
        subscribeOnline.addEventListener('click', check);
    }

}());
